import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';

const Servizi = () => {
  return (
    <>
      <Helmet>
        <title>Servizi - Informazioni e utilità - Cliccami.net</title>
        <meta name="description" content="Rassegna, comunicazioni, contatti e servizi utili per vivere meglio la città" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header onFilterClick={() => {}} />
        <main className="pt-20 pb-12">
          <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
            <h1 className="font-heading font-bold text-3xl md:text-4xl text-foreground mb-4">
              Servizi: informazioni, stampa e utilità
            </h1>
            <p className="font-body text-base text-muted-foreground">
              Rassegna, comunicazioni, contatti e servizi utili per vivere meglio la città.
            </p>
            <div className="bg-muted/50 border border-border rounded-lg p-6 mt-8">
              <p className="font-body text-sm text-muted-foreground">
                Pagina in costruzione
              </p>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default Servizi;